import { errorMessage } from "helpers/utils";
import { call, put, takeEvery } from "redux-saga/effects";

// function* fetchListJobTitle({ payload }) {
//   try {
//     const response = yield call(JobTitleService.listJobTitle, payload);
//     yield put(listJobTitleSuccess(response));
//   } catch (error) {
//     yield put(listJobTitleFail(errorMessage(error)));
//   }
// }

// function* onCreateJobTitle({ payload }) {
//   try {
//     const response = yield call(JobTitleService.createJobTitle, payload);
//     yield put(createJobTitleSuccess(response));
//   } catch (error) {
//     yield put(createJobTitleFail(errorMessage(error)));
//   }
// }

// function* onDetailJobTitle({ payload }) {
//   try {
//     const response = yield call(JobTitleService.detailJobTitle, payload);
//     yield put(detailJobTitleSuccess(response));
//   } catch (error) {
//     yield put(detailJobTitleFail(errorMessage(error)));
//   }
// }

// function* onUpdateJobTitle({ payload }) {
//   try {
//     const response = yield call(JobTitleService.updateJobTitle, payload);
//     yield put(updateJobTitleSuccess(response));
//   } catch (error) {
//     yield put(updateJobTitleFail(errorMessage(error)));
//   }
// }

// function* onDeleteJobTitle({ payload }) {
//   try {
//     const response = yield call(JobTitleService.deleteJobTitle, payload);
//     yield put(deleteJobTitleSuccess(response));
//   } catch (error) {
//     yield put(deleteJobTitleFail(errorMessage(error)));
//   }
// }

// function* onActiveJobTitle({ payload }) {
//   try {
//     const response = yield call(JobTitleService.activeJobTitle, payload);
//     yield put(activeJobTitleSuccess(response));
//   } catch (error) {
//     yield put(activeJobTitleFail(errorMessage(error)));
//   }
// }

function* routeSaga() {
  // yield takeEvery(JOB_TITLE_LIST, fetchListJobTitle);
  // yield takeEvery(JOB_TITLE_CREATE, onCreateJobTitle);
  // yield takeEvery(JOB_TITLE_DETAIL, onDetailJobTitle);
  // yield takeEvery(JOB_TITLE_UPDATE, onUpdateJobTitle);
  // yield takeEvery(JOB_TITLE_DELETE, onDeleteJobTitle);
  // yield takeEvery(JOB_TITLE_ACTIVE, onActiveJobTitle);
}

export default routeSaga;
